import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useMemo } from "react";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";

const StakeDateTabs = ({ selectedDate, onDateChange }) => {
  const today = useMemo(() => dayjs().tz(TZ), []);
  const todayString = today.format("YYYY-MM-DD");

  const dateOptions = useMemo(() => {
    const options = [];

    options.push({
      value: "live",
      label: "Trực Tiếp , Sắp diễn ra",
      type: "live",
    });

    options.push({
      value: todayString,
      label: "Hôm nay",
      type: "today",
    });

    const tomorrow = today.clone().add(1, "day");
    options.push({
      value: tomorrow.format("YYYY-MM-DD"),
      label: "Ngày mai",
      type: "tomorrow",
    });

    for (let i = 2; i <= 5; i++) {
      const d = today.clone().add(i, "day");
      options.push({
        value: d.format("YYYY-MM-DD"),
        label: d.format("DD/MM"),
        type: "future",
      });
    }

    return options;
  }, [today, todayString]);

  const getButtonClass = (isActive) => {
    const baseClass =
      "stake-date-tab-btn shrink-0 ml-[0.375rem] first:ml-0 inline-flex items-center justify-center whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-semibold transition-all active:scale-[0.98]";

    return isActive ? `${baseClass} stake-date-tab-btn--active` : baseClass;
  };

  const getMinWidth = (type) => {
    if (type === "live") return "min-w-[110px]";
    if (type === "today" || type === "tomorrow") return "min-w-[90px]";
    return "min-w-[70px]";
  };

  return (
    <div className="w-full">
      <div className="flex overflow-x-auto max-md:scrollbar-hide">
        <div className="flex shrink-0 rounded-[3rem] p-1.5 bg-[var(--stake-wrapper-bg)]">
          <div className="flex font-semibold">
            {dateOptions.map((opt) => {
              const isSelected = selectedDate === opt.value;

              return (
                <button
                  key={opt.value}
                  type="button"
                  onClick={() => onDateChange(opt.value)}
                  className={`${getButtonClass(isSelected)} ${getMinWidth(opt.type)}`}
                >
                  <span className="font-semibold">{opt.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StakeDateTabs;
